// Stored split amounts are a snapshot. Always derive checkout amounts from the
// current cart so removing, loading, or changing items cannot submit stale totals.
export function currentPaymentSplit(items, split, settings) {
  if (settings?.priceSplit?.enabled === false || !split?.isEnabled) return null;
  const rawPercentage = Number(split.cashPercentage);
  const cashPercentage = Number.isFinite(rawPercentage) ? Math.max(0, Math.min(100, rawPercentage)) : 0;
  const totals = items.reduce((total, item) => {
    const quantity = Number.isFinite(Number(item.quantity)) ? Math.max(0, Number(item.quantity)) : 1;
    const cash = Number(item.cashPrice);
    const credit = Number(item.creditPrice);
    total.cash += (Number.isFinite(cash) ? Math.max(0, cash) : 0) * quantity;
    total.credit += (Number.isFinite(credit) ? Math.max(0, credit) : 0) * quantity;
    return total;
  }, { cash: 0, credit: 0 });
  return { isEnabled: true, cashPercentage, creditPercentage: 100 - cashPercentage,
    cashAmount: totals.cash * cashPercentage / 100,
    creditAmount: totals.credit * (100 - cashPercentage) / 100 };
}
